import { useNavigate } from 'react-router-dom';
import {
    BarChart3,
    ChevronLeft,
    LayoutDashboard,
    Layers,
    Settings,
    Users,
    Workflow,
    ClipboardList,
    LogOut,
    Bell
} from 'lucide-react';
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarHeader,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    SidebarGroup,
    SidebarGroupLabel,
    SidebarGroupContent,
} from '@/components/ui/sidebar';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';

export default function AppSidebar() {
    const navigate = useNavigate();

    const menuItems = [
        { title: 'Dashboard', icon: LayoutDashboard, url: '#' },
        { title: 'Workflow View', icon: Workflow, url: '#' },
        { title: 'Modules', icon: Layers, url: '#' },
        { title: 'Reports', icon: ClipboardList, url: '#' },
        { title: 'Team', icon: Users, url: '#' },
    ];

    return (
        <Sidebar collapsible="icon">
            <SidebarHeader className="h-16 flex items-center px-4">
                <div className="flex items-center gap-3 group-data-[collapsible=icon]:hidden">
                    <img
                        src="/lincpay-logo-small.png"
                        alt="LincPay Icon"
                        className="h-8 w-8 object-contain"
                    />
                    <span className="font-bold text-lg">
                        <span className="text-blue-600">Linc</span>
                        <span className="text-green-600">Pay</span>
                    </span>
                </div>
                <div className="hidden group-data-[collapsible=icon]:flex h-8 w-8 items-center justify-center p-1">
                    <img
                        src="/lincpay-logo-small.png"
                        alt="LincPay Icon"
                        className="h-full w-full object-contain"
                    />
                </div>
            </SidebarHeader>

            <SidebarContent>
                <div className="px-4 py-4 group-data-[collapsible=icon]:hidden">
                    <Button
                        variant="outline"
                        size="sm"
                        className="w-full justify-start gap-2"
                        onClick={() => navigate('/')}
                    >
                        <ChevronLeft className="h-4 w-4" />
                        Back to Home
                    </Button>
                </div>

                <SidebarGroup>
                    <SidebarGroupLabel className="group-data-[collapsible=icon]:hidden">Main Navigation</SidebarGroupLabel>
                    <SidebarGroupContent>
                        <SidebarMenu>
                            {menuItems.map((item) => (
                                <SidebarMenuItem key={item.title}>
                                    <SidebarMenuButton asChild tooltip={item.title}>
                                        <a href={item.url}>
                                            <item.icon className="h-5 w-5" />
                                            <span>{item.title}</span>
                                        </a>
                                    </SidebarMenuButton>
                                </SidebarMenuItem>
                            ))}
                        </SidebarMenu>
                    </SidebarGroupContent>
                </SidebarGroup>

                <Separator className="mx-4 my-2 opacity-50" />

                <SidebarGroup>
                    <SidebarGroupLabel className="group-data-[collapsible=icon]:hidden">Insights</SidebarGroupLabel>
                    <SidebarGroupContent>
                        <SidebarMenu>
                            <SidebarMenuItem>
                                <SidebarMenuButton asChild tooltip="Analytics">
                                    <a href="#">
                                        <BarChart3 className="h-5 w-5" />
                                        <span>Analytics</span>
                                    </a>
                                </SidebarMenuButton>
                            </SidebarMenuItem>
                            <SidebarMenuItem>
                                <SidebarMenuButton asChild tooltip="Notifications">
                                    <a href="#">
                                        <Bell className="h-5 w-5" />
                                        <span>Notifications</span>
                                    </a>
                                </SidebarMenuButton>
                            </SidebarMenuItem>
                        </SidebarMenu>
                    </SidebarGroupContent>
                </SidebarGroup>
            </SidebarContent>

            <SidebarFooter className="p-4">
                <SidebarMenu>
                    <SidebarMenuItem>
                        <SidebarMenuButton asChild tooltip="Settings">
                            <a href="#">
                                <Settings className="h-5 w-5" />
                                <span className="group-data-[collapsible=icon]:hidden">Settings</span>
                            </a>
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                </SidebarMenu>
                <div className="mt-4 group-data-[collapsible=icon]:hidden">
                    <div className="flex items-center gap-3 rounded-lg border p-3">
                        <div className="h-8 w-8 rounded-full bg-muted flex items-center justify-center text-xs font-bold">JD</div>
                        <div className="flex-1 overflow-hidden">
                            <p className="truncate text-xs font-medium">John Doe</p>
                            <p className="truncate text-[10px] text-muted-foreground">john@example.com</p>
                        </div>
                        <Button variant="ghost" size="icon" className="h-8 w-8">
                            <LogOut className="h-4 w-4" />
                        </Button>
                    </div>
                </div>
            </SidebarFooter>
        </Sidebar>
    );
}
